export const FETCH_ORDER_LIST = "order/FETCH_ORDER_LIST";
export const FETCH_ORDER_LIST_COMPLETED = "order/FETCH_ORDER_LIST_COMPLETED";
export const FETCH_ORDER_LIST_FAILED = "order/FETCH_ORDER_LIST_FAILED";